'use client';

import { useTranslations } from 'next-intl';
import { Button } from '@ordering/components/ui/Button';

export const CookieFooterButton = () => {
  const t = useTranslations();
  return (
    <Button onClick={() => window.OneTrust?.ToggleInfoDisplay()} className="my-3">
      {t('cookie_policy_page.footer.button')}
    </Button>
  );
};
